export const banimodeUserProd = JSON.parse(
  localStorage.getItem("banimodeUserProd")!
);
export const PRODUCTS =
  "/v3/products?page_size=15&page=1&filter[product_categories.id][eq]=2801";
export const baseURLGame = "/gardone1404";
export const V1API = "/v1";
export const V2API = "/v2";
export const V3API = "/v3";
export const V4API = "/v4";
export const LOCAL_PERFIX = "gardone1402_";
export const REQUEST = "/auth/request";
export const AUTH = "/auth";
export const USER = "/user";
export const SEND_SCORE = "/send_score";
export const CLIENT_INFO = "/app/client_info";
export const LUCKY_USERS = "/lucky-users";
export const CATEGORIES = "/v1/pages/gardone1404";
export const CHECK_CHANCE = "/check-chance";
export const GET_CHANCE = "/get-chance";
export const BANIBONS = "/coupons";
export const FLASH_SALES = "/products/flash-sales";
export const MATCHES = "/matches";
export const PREDICTION = "/prediction";
export const BRANDS = "/v1/pages/testpicgame14031";
